import { fetchTagGroups } from 'actions';

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getSelectedReviewSet } from 'selectors/savedSearches';

import { useSelector } from 'store';
import EditSidebar from './EditSidebar';
import InfoSidebar from './InfoSidebar';

const ReviewSetSidebar: React.FC = () => {
  const dispatch = useDispatch();

  const [isEditing, setIsEditing] = useState(false);

  const reviewSet = useSelector(getSelectedReviewSet);

  useEffect(() => {
    setIsEditing(false);
  }, [reviewSet]);

  useEffect(() => {
    if (
      reviewSet &&
      reviewSet.config &&
      reviewSet.config.tag_values_groups_uuids &&
      reviewSet.config.tag_values_groups_uuids?.length > 0
    ) {
      dispatch(fetchTagGroups({ uuids: reviewSet.config.tag_values_groups_uuids }));
    }
  }, [dispatch, reviewSet]);

  if (!reviewSet) return null;

  if (isEditing) return <EditSidebar setEditing={setIsEditing} />;

  return <InfoSidebar setEditing={setIsEditing} />;
};

export default ReviewSetSidebar;
